import { useRef, useState } from 'react';

import { ArrowLeftLine, Edit2Line, MapPin2Line } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import { useSearchURL } from '@api/data-loaders/resource';
import Button from '@components/Button';
import useSearchBar from '@contexts/searchbar';
import { ITourSearchBarHandle } from '@components/views/tour/listing/components/TourListMobileHeader';
import TourSearchBar from '@domain/tour/searchBar';

import {
  Drawer,
  HotelDateAndGuestWrapper,
  TourMobileHeaderWrapper,
  HotelLocationWrapper,
  MobileHeaderBody,
  NavigationButton,
} from './styled';

interface Props {
  onSubmit?(): void;
}

const TourMobileHeader = ({ onSubmit }: Props) => {
  const urlData = useSearchURL();
  const {
    state: { tour: state },
  } = useSearchBar();
  const tourSearchBarRef = useRef<ITourSearchBarHandle>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleSubmit = () => {
    setIsDrawerOpen(false);
    onSubmit?.();
    tourSearchBarRef?.current?.triggerHandleSubmit();
  };

  return (
    <>
      <TourMobileHeaderWrapper>
        <NavigationButton onClick={() => window.history.back()}>
          <CustomIcon
            icon={ArrowLeftLine}
            fontSize={24}
            paletteColor='whiteAlpha600'
          />
        </NavigationButton>
        <MobileHeaderBody>
          <HotelLocationWrapper>
            <CustomIcon icon={MapPin2Line} fontSize={20} paletteColor='white' />
            <span>{urlData?.text}</span>
          </HotelLocationWrapper>
          <HotelDateAndGuestWrapper>
            {state?.searchData?.text}
          </HotelDateAndGuestWrapper>
        </MobileHeaderBody>
        <NavigationButton onClick={() => setIsDrawerOpen(true)}>
          <CustomIcon
            icon={Edit2Line}
            fontSize={24}
            paletteColor='whiteAlpha600'
          />
        </NavigationButton>
      </TourMobileHeaderWrapper>
      <Drawer
        title='Tur Arama'
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        placement='top'
        footer={
          <Button fullWidth onClick={handleSubmit}>
            Tur Ara
          </Button>
        }
      >
        <TourSearchBar
          ref={tourSearchBarRef}
          isListing={true}
          onSubmit={onSubmit}
        />
      </Drawer>
    </>
  );
};

export default TourMobileHeader;
